import React, { FC, ReactElement, ChangeEvent, useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from 'ui/CustomInput/Input.module.scss';

const cn = classNames.bind(styles);

interface Input {
  id: string;
  name: string;
  placeholder: string;
  label?: string;
  value: string;
  error?: string;
  setFormData: (state: any) => void;
  setFormErrors: (state: any) => void;
  classNames?: {
    container?: string;
    label?: string;
    labelText?: string;
    input?: string;
    error?: string;
  };
}

const Input: FC<Input> = ({
  id,
  name,
  placeholder,
  label,
  value,
  error,
  setFormData,
  setFormErrors,
  classNames,
}): ReactElement => {
  const [inputValue, setInputValue] = useState<string>('');

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    event.persist();
    setInputValue(event.target.value);

    setFormData((state: any) => {
      return {
        ...state,
        [name]: event.target.value,
      }
    });

    setFormErrors && setFormErrors((state: any) => {
      return {
        ...state,
        [name]: ''
      }
    });
  };

  return (
    <div className={cn('input', classNames?.container)}>
      <label
        className={cn('input__label', classNames?.label)}
        htmlFor={id}
      >
        {label 
          ? 
          <span className={cn('input__label-text', classNames?.labelText)}>{label}</span> 
          : 
          null
        }
        <input
          className={cn('input__input', classNames?.input, { 'error': error })}
          id={id}
          name={name}
          value={inputValue ?? ''}
          placeholder={placeholder}
          onChange={onChangeHandler}
        />
      </label>
      {error
        ?
        <p className={cn('input__error', classNames?.error)}>
          {error}
        </p>
        :
        null
      }
    </div>
  );
};

export { Input };
